// Import package components
import { useMemo, useContext, useRef, useState, useEffect } from "react";

// Import base components
import { Button } from "../../../ui";
import { AppContexts } from "../../../providers";

const Properties = ({ value, onChange, readOnly = false }) => {
  const rentalContext = useContext(AppContexts.RentalsContext);

  const dropdownProRef = useRef(null);
  const [searchValue, setSearchValue] = useState("");
  const [filteredProperties, setFilteredProperties] = useState([]);

  const properties = useMemo(() => {
    if (!rentalContext.rentals) {
      return [];
    } else {
      return rentalContext.rentals.sort((a, b) =>
        a.pms_id.localeCompare(b.pms_id),
      );
    }
  }, [rentalContext.rentals]);

  const handleInputChange = (tagId, selected) => {
    if (selected) {
      onChange([
        ...value,
        properties.find(
          (tagValue) => tagValue.rental_id.toString() === tagId.toString(),
        ),
      ]);
    } else {
      onChange(
        value.filter((tag) => tag.rental_id.toString() !== tagId.toString()),
      );
    }
  };

  const openProperties = (e) => {
    e.stopPropagation();

    if (!dropdownProRef.current.classList.contains("uk-open")) {
      let handler = () => {
        window.removeEventListener("click", handler);
        dropdownProRef.current.classList.remove("uk-open");
      };
      window.addEventListener("click", handler);
      dropdownProRef.current.classList.add("uk-open");
    }
  };

  useEffect(() => {
    setFilteredProperties(properties.filter(property => property.pms_id.toLowerCase().includes(searchValue)));
  }, [properties, searchValue]);

  return (
    <div className="uk-flex uk-flex-top" onClick={openProperties}>
      <div>
        <Button>
          <img src="/images/rental.svg" />
        </Button>
        <div className="uk-dropdown guest-tags-dropdown" ref={dropdownProRef}>
          <div className="uk-search uk-search-default uk-margin-small-bottom">
            <span className="uk-search-icon-flip uk-icon uk-search-icon" uk-search-icon="true" onClick={() => setSearchValue('')}>
              <svg width="20" height="20" viewbox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                <circle fill="none" stroke="#000" stroke-width="1.1" cx="9" cy="9" r="7" />
                <path fill="none" stroke="#000" stroke-width="1.1" d="M14,14 L18,18 L14,14 Z" />
              </svg>
            </span>
            <input className="uk-input" type="input" placeholder="Search" value={searchValue} onChange={(e) => setSearchValue(e.target.value)} />
          </div>
          <ul className="uk-nav uk-dropdown-nav tags-selector">
            {filteredProperties.map(
              (property, index) =>
                property.pms_id != "" && (
                  <li key={index}>
                    <label>
                      <input
                        className="uk-checkbox"
                        type="checkbox"
                        checked={
                          value?.findIndex(
                            (tag) =>
                              tag.rental_id.toString() ===
                              property.rental_id.toString(),
                          ) >= 0
                        }
                        onChange={
                          readOnly
                            ? () => {}
                            : (event) =>
                                handleInputChange(
                                  property.rental_id,
                                  event.target.checked,
                                )
                        }
                      />
                      {property.pms_id}
                    </label>
                  </li>
                ),
            )}
          </ul>
        </div>
      </div>
      <div className="hms-guest-tags">
        <div className="guest-tags">
          {value &&
            value.map((property, index) => (
              <div className="uk-inline" key={index}>
                {property.pms_id}
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default Properties;
